import React, { useContext } from 'react';
import { Button, Divider, FormControl, Grid } from '@mui/material';
import AuthContext from '../../Common/AuthContext';
import { FormTextField, FormToggle } from '../../Common/FormItems';
import { AuthContextValue } from '../../Common/types';

type Props = {
  values: any;
  handleChange: any;
  errors: any;
  submitDisabled: boolean;
  isCreate: boolean;
  removal?: () => void;
};

const FaqForm: React.FC<Props> = (props) => {
  const { hasPermissions } = useContext(AuthContext) as AuthContextValue;

  return (
    <div>
      <Grid container spacing={2} style={{ marginBottom: '20px' }}>
        <FormTextField
          size={12}
          fieldName="question"
          label="Fråga"
          placeholder="Fråga"
          values={props.values}
          errors={props.errors}
          onChange={props.handleChange}
          multiline={true}
        />
        <FormTextField
          size={12}
          fieldName="answer"
          label="Svar"
          placeholder="Svar"
          values={props.values}
          errors={props.errors}
          onChange={props.handleChange}
          multiline={true}
        />
      </Grid>

      <Grid container spacing={2} style={{ marginBottom: '20px' }}>
        <FormTextField
          size={2}
          fieldName="ranking"
          label="Prioritering"
          placeholder="t. ex. 1"
          values={props.values}
          errors={props.errors}
          onChange={props.handleChange}
          multiline={true}
        />
      </Grid>
      <Grid container spacing={2} style={{ marginBottom: '20px' }}>
        <FormToggle size={4} fieldName="show" label="Visa" values={props.values} onChange={props.handleChange} />
      </Grid>

      <Divider className="!mb-5" />

      <Grid container spacing={2} alignItems="center" style={{ marginBottom: '20px' }}>
        <Grid item xs={5} />
        <Grid item xs={2}>
          <FormControl variant="standard" margin="dense" required fullWidth>
            <Button
              type="submit"
              color="primary"
              variant="contained"
              disabled={props.submitDisabled || !hasPermissions(['admin', 'operational_leader'])}
            >
              {props.isCreate ? 'Lägg till' : 'Spara'}
            </Button>
          </FormControl>
        </Grid>
        <Grid item xs={3} />
        {!props.isCreate && (
          <Grid item xs={2}>
            <FormControl variant="standard" margin="dense" required fullWidth>
              <Button
                variant="contained"
                color="error"
                disabled={!hasPermissions(['admin', 'operational_leader'])}
                onClick={(): void => {
                  if (props.removal) props.removal();
                }}
              >
                Ta Bort
              </Button>
            </FormControl>
          </Grid>
        )}
      </Grid>
    </div>
  );
};

export default FaqForm;
